function switchTab(activetab = 'tab1', prefix = '') {
    const tabgroups = document.querySelectorAll(`.${prefix}tabgroup`);

    Array.from(tabgroups).forEach(tab => {
        const {
            id
        } = tab;
        const tabLink = document.getElementById(`${id}link`);

        if (id !== activetab) {
            tab.classList.remove(prefix === 'prtab-' ? 'is-visible' : 'open-tab');
            if (tabLink) tabLink.classList.remove('is-visible');
        } else {
            tab.classList.add(prefix === 'prtab-' ? 'is-visible' : 'open-tab');
            if (tabLink) tabLink.classList.add('is-visible');
        }
    });

    return false;
}

function hpEshopMenuShow() {
    const hpEshopMenu = document.querySelector('.hp-eshop-menu');
    const hpEshopMenuToggle = document.querySelector('.hp-eshop-menu__toggle');
    const hpEshopMenuToggleTitle = hpEshopMenuToggle.dataset.titleHide;
    hpEshopMenu.classList.add('hp-eshop-menu--expanded');

    hpEshopMenuToggle.classList.remove('hp-eshop-menu__toggle--more');
    hpEshopMenuToggle.classList.add('hp-eshop-menu__toggle--less');
    hpEshopMenuToggle.setAttribute('title', hpEshopMenuToggleTitle);

    hpEshopMenuToggle.addEventListener('click', hpEshopMenuHide, {
        once: true
    });
};

function hpEshopMenuHide() {
    const hpEshopMenu = document.querySelector('.hp-eshop-menu');
    const hpEshopMenuToggle = document.querySelector('.hp-eshop-menu__toggle');
    const hpEshopMenuToggleTitle = hpEshopMenuToggle.dataset.titleShow;
    hpEshopMenu.classList.remove('hp-eshop-menu--expanded');

    hpEshopMenuToggle.classList.remove('hp-eshop-menu__toggle--less');
    hpEshopMenuToggle.classList.add('hp-eshop-menu__toggle--more');
    hpEshopMenuToggle.setAttribute('title', hpEshopMenuToggleTitle);

    hpEshopMenuToggle.addEventListener('click', hpEshopMenuShow, {
        once: true
    });
}

hpEshopMenuHide();


// Custom slider
function slider() {
    const timeout = 10000; // ms (the time between changes)
    const speed = 1000; // ms (the time of transitions)
    const delay = 0; // ms (the time before transition starts)
    const showMenu = 1;

    let slideIndex = 0;
    let timeoutId;
    let sliderMenuMade = 0;
    const loadedFlags = {};
    const styleSheet = document.styleSheets[0];
    styleSheet.insertRule('.slide { opacity: 0; transition: opacity 0ms ease-in-out ' + delay + 'ms; }', 0);

    function removeDataPrefix(parentElement, index) {
        let elementsToUpdate = parentElement.querySelectorAll('[data-srcset], [data-src]');
        if (elementsToUpdate.length > 0) {
            elementsToUpdate.forEach(element => {
                Array.from(element.attributes).forEach(attribute => {
                    if (attribute.name && attribute.name.startsWith('data-')) {
                        let attributeNameWithoutData = attribute.name.replace('data-', '');
                        element.setAttribute(attributeNameWithoutData, attribute.value);
                        element.removeAttribute(attribute.name);
                    }
                });
            });
            markElementAsLoaded(index);
            // console.log("Loading slide: " + index);
        }
    }

    function makeSliderMenu() {
        const sliderMenu = document.createElement('div');
        sliderMenu.id = 'slider-menu';
        sliderMenu.classList.add('slider-menu');

        const sliderElement = document.getElementById('slider');
        if (sliderElement) {
            sliderElement.appendChild(sliderMenu);
            sliderMenuMade = 1;
        }
    }

    function showSlideInMenu(parentElement, index) {
        const sliderMenuItem = document.createElement('span');
        sliderMenuItem.classList.add('slider-menu__item');

        const sliderMenu = document.getElementById('slider-menu');
        if (sliderMenu) {
            sliderMenu.appendChild(sliderMenuItem);
            sliderMenuItem.addEventListener('mouseover', () => removeDataPrefix(parentElement, index), {
                once: true
            });
            sliderMenuItem.addEventListener('click', () => showSlides(index));
        }
    }

    function isElementLoaded(index) {
        return loadedFlags[index];
    }

    function markElementAsLoaded(index) {
        loadedFlags[index] = true;
    }

    function showSlides(activateSlide) {
        if (activateSlide && timeoutId) {
            clearTimeout(timeoutId);
        }

        let slides = document.querySelectorAll(".slide");

        if (slides.length > 0) {

            if (showMenu && sliderMenuMade !== 1 && slides.length > 1) {
                makeSliderMenu();
            }

            slides.forEach((slide, index) => {
                slide.style.opacity = 0;

                if (slideIndex === 0) {
                    slide.style.transition = 'opacity ' + speed + 'ms ease-in-out ' + delay + 'ms';
                    slide.style.display = 'block';
                    if (showMenu) {
                        showSlideInMenu(slide, ++index);
                    }
                }
            });

            if (slideIndex === 0) {
                slideIndex = 1;
            }

            if (showMenu && activateSlide) {
                slideIndex = activateSlide;
            }

            if (slideIndex > slides.length) {
                slideIndex = 1;
            }

            slides[slideIndex - 1].style.opacity = 1;

            if (showMenu) {
                let sliderMenuItems = document.querySelectorAll(".slider-menu__item");
                if (sliderMenuItems && sliderMenuItems.length > 0) {
                    sliderMenuItems.forEach(item => {
                        item.classList.remove("active");
                    });
                    if (slideIndex > 0 && slideIndex <= sliderMenuItems.length) {
                        sliderMenuItems[slideIndex - 1].classList.add("active");
                    }
                }
            }

            if (!isElementLoaded(slideIndex + 1) && slideIndex < slides.length) {
                removeDataPrefix(slides[slideIndex], (slideIndex + 1));
            } else {
                if (slideIndex < slides.length) {
                    // console.log('Slide with index ' + (slideIndex + 1) + ' is already loaded');
                }
            }

            slideIndex++;

            timeoutId = setTimeout(showSlides, timeout);
        }
    }

    showSlides();
}

document.addEventListener("DOMContentLoaded", slider);


// Safari 16.1 - 16.4 AVIF issue workaround - applied on the slider images only
function isBuggySafari() {
    const userAgent = navigator.userAgent;
    return /^(?!.*Chrome).*Version\/16\.[1-4].*Safari/.test(userAgent);
}

function removeAvifSources() {
    const pictureElements = document.querySelectorAll('#slider picture');
    pictureElements.forEach(pictureElement => {
        const avifSources = pictureElement.querySelectorAll('source[type="image/avif"]');
        avifSources.forEach(avifSource => {
            avifSource.remove();
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    if (isBuggySafari()) {
        removeAvifSources();
    }
});